import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Rückkehr vom Google-OAuth: AuthCallback übernimmt die Session
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    const token = localStorage.getItem("vmffm_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("vmffm_token"))
      .finally(() => setLoading(false));
  }, []);

  const applySession = (data) => {
    localStorage.setItem("vmffm_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return applySession(data);
  };

  const logout = () => {
    localStorage.removeItem("vmffm_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, applySession, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const roleHome = (role) => (role === "customer" ? "/portal" : "/app");
